export { FullSlide } from './FullSlide';
export { MainSlide } from './MainSlide';
